import React from 'react';

import ButtonInner from './Inner';
import { ButtonProps } from './types';

import './style.scss';

const Button: React.FC<ButtonProps> = (props) => {
  const {
    children,
    ...buttonProps
  } = props;

  if ('href' in props) {
    const { href } = props;

    return (
      <ButtonInner {...buttonProps} href={href}>
        {children}
      </ButtonInner>
    );
  }

  // If no `href` is present in props, render a <button></button>.
  const { htmlType = 'button' } = props;

  return (
    <ButtonInner {...buttonProps} htmlType={htmlType}>
      {children}
    </ButtonInner>
  );
};

export default Button;
